import * as angular from 'angular';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { Observable } from 'rxjs';
import { AccountFacade } from '@mode/accounts/contract';

export const MembersPanelComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['FeatureFlagsFacade', 'AccountFacade'];

    private adminEnabled!: boolean;
    private historyLink!: string;
    private memberSessionsLink!: string;
    private newInviteLink!: string;
    private orgName!: string;
    private orgUsername!: string;
    private scimTooltipEnabled$: Observable<boolean>;
    private thoughtspotIntegrated!: boolean;
    private orgIsManagedByScim: boolean | undefined;
    private orgSeatLimitReached = false;

    constructor(private featureFlagsFacade: FeatureFlagsFacade, private accountFacade: AccountFacade) {
      this.scimTooltipEnabled$ = this.featureFlagsFacade.asObservable(FeatureFlag.AzureActiveDirectoryScim);
      this.accountFacade.hasOrgSeatLimitReached$.subscribe((value) => (this.orgSeatLimitReached = value));
    }

    displaySettingsDropdown() {
      return this.historyLink || this.memberSessionsLink;
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    adminEnabled: '<',
    historyLink: '<',
    orgIsManagedByScim: '<',
    limitedMembershipsEnabled: '<',
    memberFilter: '<',
    memberSessionsLink: '<',
    newInviteLink: '<',
    orgName: '<',
    orgUsername: '<',
    scimEnabled: '<',
    thoughtspotIntegrated: '<',
  },
  template: `
    <div class="members-panel">
      <div class="members-panel-header">
        <div class="header-title">
          <h3 class="heading">Members</h3>

          <!-- TODO Franklin (10.02.2018) - Move to separate component -->
          <div class="member-settings-dropdown" ng-if="ctrl.displaySettingsDropdown()" uib-dropdown>
            <div class="member-settings-dropdown-control" uib-dropdown-toggle>
              <i class="icon-gear-outlined-dark mdlg-icon"></I>
            </div>
            <ul class="member-settings-dropdown-menu dropdown-menu" uib-dropdown-menu>
              <li ng-if="ctrl.historyLink">
                <a ng-href="{{ctrl.historyLink}}">History</a>
              </li>
              <li ng-if="ctrl.memberSessionsLink">
                <a ng-href="{{ctrl.memberSessionsLink}}">Manage Member Sessions</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="header-actions">
          <span
             class="invite-button-container"
             ng-if="!ctrl.thoughtspotIntegrated"
             uib-tooltip="{{ ctrl.orgName }} Memberships are managed through SCIM"
             tooltip-enable="(ctrl.scimTooltipEnabled$ | async:this) && ctrl.orgIsManagedByScim"
             tooltip-append-to-body="true"
             tooltip-placement="bottom"
             tooltip-class="wrapping-tooltip-lg"
             tooltip-popup-delay="500"
          >
            <capra-button-link
              [disabled]="(ctrl.scimTooltipEnabled$ | async:this) && ctrl.orgIsManagedByScim"
              ng-if="!(ctrl.orgSeatLimitReached)"
              text="Invite to {{ ctrl.orgName }}"
              [href]="ctrl.newInviteLink"
              variant="primary"
              size="medium"
            ></capra-button-link>
          </span>
        </div>
      </div>
      <div class="members-panel-body">
        <members-browser
          admin-enabled="ctrl.adminEnabled"
          org-username="ctrl.orgUsername"
          org-name="ctrl.orgName"
          limited-memberships-disabled="ctrl.limitedMembershipsDisabled"
          member-filter="ctrl.memberFilter"
          scim-enabled="ctrl.scimEnabled"
          thoughtspot-integrated="ctrl.thoughtspotIntegrated"
        />
      </div>
    </div>
  `,
};
